import React, { } from 'react'

// Surat Statis
import ModalSuratTidakMampu from '../modal/tidak-mampu';
import ModalBlangkoNikah from '../modal/blangko-nikah';
import ModalSuratPindahWNI from '../modal/pindah-wni';
// End Surat Statis

// Generate Form Surat
import ModalGenerateForm from '../pelayanan-surat/modal/surat-generate-form';
// Generate Form Surat

function ModalUpdate({ jenis_surat, detail_surat_context, data, fieldInputan, statusData, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData }) {

  // return (
  //   <div>
  //     <ModalGenerateForm
  //       data={data}
  //       isOpen={isOpen}
  //       propsData={propsData}
  //       kiosk={false}
  //       fieldInputan={fieldInputan}
  //       statusData={statusData}
  //       optionData={optionData}
  //       setAlert={setAlert}
  //       setStatusRefresh={setStatusRefresh}
  //       setIsOpen={setIsOpen}
  //     />
  //   </div>
  // )

  // Format Surat Lama
  switch (jenis_surat) {
      case 'Surat Keterangan Tidak Mampu':
      return (
        <div>
          <ModalSuratTidakMampu
            data={data}
            isOpen={isOpen}
            propsData={propsData}
            kiosk={false}
            optionData={optionData}
            setAlert={setAlert}
            setStatusRefresh={setStatusRefresh}
            setIsOpen={setIsOpen}
          />
        </div>
      )
      //break;
      case 'Blangko Nikah':
      return (
        <div>
          <ModalBlangkoNikah
						data={data}
						isOpen={isOpen}
						propsData={propsData}
            kiosk={false}
						optionData={optionData}
						setAlert={setAlert}
						setStatusRefresh={setStatusRefresh}
						setIsOpen={setIsOpen}
          />
        </div>
      )
      //break;
      case 'Surat Keterangan Pindah Datang WNI':
      return (
        <div>
          <ModalSuratPindahWNI
						data={data}
						isOpen={isOpen}
						propsData={propsData}
            kiosk={false}
						optionData={optionData}
						setAlert={setAlert}
						setStatusRefresh={setStatusRefresh}
						setIsOpen={setIsOpen}
          />
        </div>
      )
      //break;
      default:
      return (
        <div>
          <ModalGenerateForm
            data={data}
            isOpen={isOpen}
            propsData={propsData}
            kiosk={false}
            fieldInputan={fieldInputan}
            statusData={statusData}
            optionData={optionData}
            setAlert={setAlert}
            setStatusRefresh={setStatusRefresh}
            setIsOpen={setIsOpen}
          />
        </div>
      )
      //break;
  }
}

export default ModalUpdate